import React from "react";
import BlueTag from "../../ui/BlueTag";
import Heading from "../../ui/Heading";
import Paragraph from "../../ui/Paragraph";
import Icons from "../../components/Icons";
import Cta from "../../ui/Cta";
import ImageCards from "./ImageCards";
import { Link } from "react-router-dom";
import Hero from "../Hero";
import BusinessSuccess from "../../../about-us/BusinessSuccess";
import cardImage1 from "../../../../assets/images/webp/about-m-sml.webp";
import cardImage2 from "../../../../assets/images/webp/about-m-larg.webp";
import author from "../../../../assets/images/webp/testimonials-avatar-7.webp";

const About = () => {
  const AboutList = {
    title: "A journey driven by passion and innovation",
    description: [
      "At Make Way India, we are dedicated to transforming visions into reality through innovation and strategic excellence. With a focus on sustainable growth, our expertise spans diverse industries, ensuring impactful solutions that resonate with our clients' needs.",
      "With a focus on leveraging advanced technologies and deep industry expertise, we deliver tailored solutions designed to meet our clients' unique needs. Our commitment to quality and excellence has been the cornerstone of our success.",
    ],

    infoHeading: "Building connections that inspire growth and innovation",
    cta: false,
    author: {
      name: "Deepak Sharma",
      role: "Founder & CEO",
      img: author,
    },
    second: {
      title: "",
      description: [
        "We take pride in delivering over 12,000 successful projects across diverse industries, achieving meaningful results for our clients worldwide.",
      ],
      img1: cardImage1,
      img2: cardImage2,
    },
  };
  return (
    <div className="pb-48">
      <Hero value={0} />
      {AboutList && (
        <div className="bg-white pt-10 sm:pt-14 md:pt-20 lg:pt-24 pb-14 sm:pb-16 md:pb-24 lg:pb-28 xl:pb-[140px]">
          <div className="container  mx-auto max-lg:px-3.5 max-md:px-6">
            <div className="flex max-xl:flex-col gap-y-8  gap-x-[57px]">
              <div className="max-lg:max-w-[714px] xl:max-w-[500px] 2xl:max-w-[700px] w-full mx-auto 2xl:ml-0">
                <BlueTag>About us</BlueTag>

                <Heading
                  className={`pt-1 max-xl:mx-auto xl:max-w-[456px]  2xl:max-w-[600px] `}
                >
                  {AboutList.title}
                </Heading>
                {AboutList.description.map((detail, index) => (
                  <Paragraph
                    key={index}
                    className="pt-3 max-w-[778px] xl:max-w-[500px]  2xl:max-w-[600px]"
                  >
                    {detail}
                  </Paragraph>
                ))}

                {AboutList.listBadges && (
                  <div className="inline-flex flex-col gap-y-4 pt-5">
                    {AboutList.listBadges.map((obj, index) => (
                      <div
                        key={index}
                        className="inline-flex items-center  gap-x-1.5"
                      >
                        <Icons
                          className="min-w-[18px]"
                          icon="blue-check-mark"
                        />
                        <p className="font-semibold text-sm !leading-130 text-custom-dark-blue">
                          {obj}
                        </p>
                      </div>
                    ))}
                  </div>
                )}
                {AboutList.infoHeading && (
                  <h3 className="font-bold !leading-150 text-base md:text-lg text-custom-dark-blue sm:max-w-[768px] xl:max-w-[421px] pt-4 md:pt-6  2xl:max-w-[600px]">
                    {AboutList.infoHeading}
                  </h3>
                )}
                {AboutList.cta && (
                  <Cta className="max-sm:w-full mt-4 sm:mt-6 md:mt-8">
                    <Link to="/contact-us">Get A Quote</Link>
                  </Cta>
                )}
                {AboutList.author && (
                  <div className="flex items-center gap-x-3 mt-3 md:mt-5">
                    <img
                      src={AboutList.author.img}
                      alt="author"
                      className="size-11 object-cover rounded-full overflow-clip"
                    />
                    <div>
                      <h3 className=" text-custom-dark-blue text-sm font-semibold !leading-133">
                        {AboutList.author.name}
                      </h3>
                      <p className="text-xs !leading-155 font-normal pt-1 text-custom-dark-blue">
                        {AboutList.author.role}
                      </p>
                    </div>
                  </div>
                )}
              </div>
              <div className={` flex grow xl:max-w-[583px] 2xl:max-w-[42%] `}>
                <ImageCards detail={AboutList.second} />
              </div>
            </div>
          </div>
        </div>
      )}{" "}
      <BusinessSuccess />
    </div>
  );
};

export default About;
